import Sidebar from './SideBar.vue'
import SidebarLink from './SidebarLink.vue'
import { reactive } from 'vue'

const SidebarStore = reactive({
  showSidebar: false,
  sidebarLinks: [
    {
      name: 'Dashboard',
      icon: 'ti-panel',
      path: '/overview'
    }
  ],
  displaySidebar (value) {
    this.showSidebar = value
  }
})

const SidebarPlugin = {
  install (app) {
    app.mixin({
      data () {
        return {
          sidebarStore: SidebarStore
        }
      }
    })

    app.config.globalProperties.$sidebar = SidebarStore
    
    app.component('side-bar', Sidebar)
    app.component('sidebar-link', SidebarLink)
  }
}

export default SidebarPlugin
